export default __webpack_public_path__ + "static/media/logo.175a6cf7.png";